import { Dimensions } from "react-native";

const latitudeDelta = 0.005;
const { width, height } = Dimensions.get("window");

export const SCREEN_HEIGHT = height;
export const SCREEN_WIDTH = width;
export const SCREEN_ASPECT_RATIO = height / width;

export const MAP_ICON_SIZE = {
  width: 65,
  height: 70,
};
export const DETAILS_MAP_ZOOM_LEVEL = 15;
export const NATIVE_MAP_ZOOM_LEVELS = {
  android: {LATITUDE_DELTA: latitudeDelta, LONGITUDE_DELTA: latitudeDelta * SCREEN_ASPECT_RATIO},
  ios: {LATITUDE_DELTA: latitudeDelta, LONGITUDE_DELTA: latitudeDelta * SCREEN_ASPECT_RATIO},
};